export const createStyles = (theme?: any) => {
  const isDark = theme?.palette?.mode == 'dark';

  return {
    wrapper: {
      width: '100%',
      height: '100%',
    },
    modalHeader: {
      display: 'flex',
      flexShrink: 0,
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '16px',
    },
    modalTitle: {
      fontSize: '20px',
      fontWeight: 500,
      lineHeight: '160%',
      letterSpacing: '0.15px',
      color: theme?.palette?.text?.primary,
    },
    modalClose: {
      color: isDark ? '#FFFFFF8F' : theme?.palette?.grey?.[500],
      flexShrink: 0,
      mt: '-0.3rem',
      mr: '-0.5rem',
    },
  };
};
